<template>
  <div class="content">
    <PageHeader title="Entry Home"></PageHeader>
    <v-container class="page-bottom pa-0">
      <v-row>
        <v-col>
          <div v-if="invalidEntry">
            <h3>Invalid entry</h3>
            <div>This entry could belong to a different Fanhive account. Try log in to that one.</div>
          </div>
          <v-card
            outlined
             v-if="entry"
          >
            <v-container class="pb-5">
              <v-row>
                <v-col>
                  <EntryHeader  :entry="entry"></EntryHeader>
                </v-col>
              </v-row>
              <v-row class="mt-0" v-if="!competitionEnded">
                <v-col>
                  <EntryButtons :entry="entry"></EntryButtons>
                </v-col>
              </v-row>
              <v-row class="mt-0 text-center" v-if="competitionEnded">
                <v-col>
                  This competition has expired
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  Keep checking back here or your email for competition information.
                </v-col>
              </v-row>
            </v-container>
          </v-card>
          <v-container class="mt-2">
            <v-row>
                <v-col>
                  <router-link :to="{name: 'my-entries'}">Back to my entries</router-link>
                </v-col>
                <v-col class="text-right">
                  <router-link :to="{name: 'active-competitions'}">Go to competitions</router-link>
                </v-col>
              </v-row>
          </v-container>
        </v-col>
      </v-row>
    </v-container>
    <v-overlay
      :absolute="false"
      :value="overlay"
      :opacity="0.9"
      >
      <v-progress-circular
        indeterminate
        color="amber"
        :size="70"
        :width="7"
      ></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import PageHeader from './../../components/PageHeader';
import EntryHeader from './EntryHeader.vue';
import EntryButtons from './EntryButtons.vue';
import moment from 'moment'

export default {
  name: 'entryhome',
  components: {
    PageHeader,
    EntryHeader,
    EntryButtons
  },
  data: () => ({
    entry: null,
    overlay: false,
    entryQuestionsAnswers: null,
    invalidEntry: false
  }),
  computed: {
    competitionEnded () {
      return moment() > moment(this.entry.competitionEndDate)
    }
  },
  methods: {
    getEntry: function () {
      var scope = this;
      this.overlay = true;

      var slugParams = {
        slug: 'myentry',
        params: `&entry_id=${scope.$route.query.entryId}&user_id=${scope.$store.getters.userSub.id}`
      };

      this.$store.dispatch('getCustom', slugParams).then(getEntryResponse => {
        scope.entry = getEntryResponse;
        if(!scope.entry){
          scope.invalidEntry = true;
        }

        if(scope.$route.query.answered !== undefined && scope.entry.answered === null){
          console.log('marking as answered');
          scope.entry.answered = Number(scope.$route.query.answered)
        }

        scope.overlay = false;
      }, error => {

          scope.overlay = false;
          console.log(error);
          scope.$store.commit('setRedirectLink', '/competitions/entry-home?entryId=' + scope.$route.query.entryId);
          scope.$router.push({name: 'logout', query: {redirect: true}});
      });
    }
  },
  created () {
    this.overlay = true;
    this.getEntry();
  }
}
</script>